import { useTranslation } from "react-i18next";
import { Badge } from "@/shared/components/ui/badge";
import type { Role } from "@/shared/types/role";
import { isAdminRole } from "@/shared/types/role";
import { roleLabelKey } from "./format-user";

interface UserRoleBadgeProps {
  readonly role: Role;
}

export function UserRoleBadge({ role }: UserRoleBadgeProps) {
  const { t } = useTranslation();
  return (
    <Badge data-testid={`user-role-${role}`} variant={isAdminRole(role) ? "default" : "outline"}>
      {t(roleLabelKey(role))}
    </Badge>
  );
}
